import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import useInputValidation from "../../hooks/useInputValidation";
import "./modals.css";
import closeIcon from "../../assets/close.svg";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import { setEmailVerification, setFirstTimeUser, setOTPRequested, setRedirectionUrl, setShowLoginModal } from "../../store/authentication/authentication.slice";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import { SubmitEvent } from "../../utils/constants/Types.constants";
import validateDomain from "../../utils/helpers/validateDomain";
import editIcon from "../../assets/edit-pencil.svg";
import OTPInput from "react-otp-input";
import { checkEmail, registerNewUser, verifyotp } from "../../store/authentication/authentication.actions";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import { getWithoutCredentials, postWithoutCredentials } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import openURL from "../../utils/helpers/openURL";
import { useNavigate } from "react-router-dom";

const LoginModal: React.FunctionComponent = () => {
  interface LoginInterface {
    email: string;
    otp: string;
  }

  interface RegisterInterface {
    phone: string;
    organisation: string;
    // pan?: string | undefined;
    // gstin?: string | undefined;
    // billing_address: string;
    // authorised_signatory: string
  }

  interface CheckboxRegisterInfo {
    [key: string]: boolean;
  }

  const isUIMounted = useRef(false)
  const [checkboxRegisterInfo, setCheckboxRegisterInfo] = useState<CheckboxRegisterInfo>({});
  const checkboxRefs = useRef<{ [key: string]: React.RefObject<HTMLInputElement> }>({});

  const { bindValue, reset } = useInputValidation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const userState = useAppSelector(StoreSelectors.USER_STATE);

  const [loginInfo, setLoginInfo] = useState<LoginInterface>({
    email: "",
    otp: "",
  });
  const [registerInfo, setRegisterInfo] = useState<RegisterInterface>({
    phone: "",
    organisation: "",
    // pan: "",
    // gstin: "",
    // billing_address: "",
    // authorised_signatory: ""
  });
  const [otpSeconds, setOtpSeconds] = useState(30);
  const [otpMinutes, setOtpMinutes] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [OTPResent, setOTPResent] = useState(false);
  const [resentCount, setResentCount] = useState(1);
  const [userCategoryData, setUserCategoryData] = useState<any>([]);
  const [isPrimaryUser, setIsPrimaryUser] = useState(false)

  useEffect(() => {
    if (userState.OTPRequested) {
      const interval = setInterval(() => {
        if (otpSeconds > 0) {
          setOtpSeconds(otpSeconds - 1);
        }

        if (otpSeconds === 0) {
          if (otpMinutes === 0) {
            clearInterval(interval);
          } else {
            setOtpSeconds(59);
            setOtpMinutes(otpMinutes - 1);
          }
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [otpSeconds, userState.OTPRequested]);

  /** Capture input values */
  const setInputValue = (ev: any) => {
    setErrorMsg("");

    if (userState.emailVerified === true && userState.OTPRequested === false) {
      setRegisterInfo({ ...registerInfo, [ev.target.name]: ev.target.value });
      return;
    }

    if (typeof ev !== "object") {
      setLoginInfo({ ...loginInfo, otp: ev });
      return;
    }

    setLoginInfo({ ...loginInfo, [ev.target.name]: ev.target.value });
    // if (ev.target.name === "email") {
    //   setLoginInfo({ ...loginInfo, [ev.target.name]: ev.target.value.toLowerCase() });
    // } else {
    //   setLoginInfo({ ...loginInfo, [ev.target.name]: ev.target.value });
    // }

  };

  /** Submit login
   *  register form
   * */
  const onSubmitForm = async (ev: SubmitEvent) => {
    ev.preventDefault();

    if (loginInfo.email.length <= 9) {
      return;
    }

    let emailValid = validateDomain(loginInfo.email);

    if (emailValid === false) {
      setErrorMsg("Only organisation managed email IDs allowed.");
    }

    if (emailValid) {
      setErrorMsg("");
      let returnResponse = await dispatch(checkEmail({ email: loginInfo.email }));
      // let returnResponse = await dispatch(checkEmail({ email: loginInfo.email.toLowerCase() }));

      if (returnResponse.requestedOTP) {
        setOtpSeconds(30);
        setOtpMinutes(0);
      }
    }
  };

  const onSubmitOTPForm = async (ev: SubmitEvent) => {
    ev.preventDefault();

    if (loginInfo.otp.length !== 6) {
      return;
    }
    const returnResponse = await dispatch(verifyotp({ email: loginInfo.email, otp: loginInfo.otp }));

    if (returnResponse.firstTimeUser === null) {
      await getUserCategoryData();
      return;
    }

    if (returnResponse.firstTimeUser === false && userState.redirectionUrl !== '') {
      navigate(userState.redirectionUrl);
      dispatch(setRedirectionUrl(''))
    }

    if (returnResponse.firstTimeUser === true && returnResponse.firstTimeUser !== null) {
      await getUserCategoryData()
      setIsPrimaryUser(returnResponse.isPrimaryUser)

      if (returnResponse.isPrimaryUser !== true) {
        setRegisterInfo({ organisation: returnResponse.primaryUserData.organization_name, phone: '',
          //  pan: '', gstin: '', billing_address: '', authorised_signatory: '' 
          });

        let temp: any = {}

        userCategoryData.forEach((category: any) => {
          if (returnResponse.primaryUserData.user_category.includes(category.id)) {
            temp = { ...temp, [category.name]: true }
          } else {
            temp = { ...temp, [category.name]: false }
          }
        })
        setCheckboxRegisterInfo(temp)
      }
    }

    if (returnResponse.firstTimeUser !== true && returnResponse.firstTimeUser !== null) {
      setLoginInfo({ email: "", otp: "" });
      reset();
      setOtpSeconds(0);
      setOtpMinutes(0);
      dispatch(setShowLoginModal(false));
      setErrorMsg("");

    }

  };
  /** Send OTP */
  const sendOTP = async () => {
    let payload = { email: userState.user.email.toLowerCase() };

    const response = await postWithoutCredentials(APIList.USER_RESEND_OTP, payload);

    return response;
  };

  /** Resend OTP call */
  const resendOTP = async () => {
    const response = await dispatch(sendOTP);
    setLoginInfo({ ...loginInfo, otp: '' })
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      if (resentCount + 1 === 2) {
        setOtpSeconds(30);
        setOtpMinutes(1);
        setResentCount(resentCount + 1);
      } else if (resentCount + 1 === 3) {
        setOtpSeconds(59);
        setOtpMinutes(2);
        setResentCount(resentCount + 1);
      } else if (resentCount + 1 >= 3) {
        setOtpSeconds(30);
        setOtpMinutes(0);
        setResentCount(1);
        return;
      }
      setOTPResent(true);

      setTimeout(() => {
        setOTPResent(false);
      }, 5000);
    }
  };

  const closeModal = () => {
    dispatch(setOTPRequested(false));
    reset();
    setErrorMsg("");
    setLoginInfo({ email: "", otp: "" });
    setRegisterInfo({
      phone: "",
      organisation: "",
      // pan: "",
      // gstin: "",
      // billing_address: "",
      // authorised_signatory: ""
    });
    dispatch(setShowLoginModal(false));
    dispatch(setEmailVerification(false));
    dispatch(setOTPRequested(false));
    dispatch(setFirstTimeUser(false));
    setOtpSeconds(0);
    setOtpMinutes(0);
    setResentCount(1);
  };

  // back to email edit
  const editEmail = () => {
    setLoginInfo({ email: loginInfo.email, otp: "" });
    dispatch(setEmailVerification(false));
    dispatch(setOTPRequested(false));
    setOtpSeconds(0);
    setOtpMinutes(0);
    setResentCount(1);
  };

  useEffect(() => {
    if (isUIMounted.current === true) return
    isUIMounted.current = true
    getUserCategoryData();
  }, []);

  const getUserCategoryData = async () => {
    const response = await getWithoutCredentials(APIList.USER_GET_CATEGORY);
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      const filteredData = response.data.filter((value: any) => value.status === true);
      setUserCategoryData(filteredData);

      const initialRegisterInfo: CheckboxRegisterInfo = {};
      filteredData.forEach((item: any) => {
        if (!checkboxRegisterInfo.hasOwnProperty(item.name)) {
          initialRegisterInfo[item.name] = false;
        }
      });
      setCheckboxRegisterInfo((prevRegisterInfo) => ({ ...prevRegisterInfo, ...initialRegisterInfo }));

      checkboxRefs.current = filteredData.reduce((acc: any, item: any) => {
        acc[item.name] = React.createRef<HTMLInputElement>();
        return acc;
      }, {} as { [key: string]: React.RefObject<HTMLInputElement> });

    } else {
      console.log("Error");
    }
    return response;
  };

  const setCheckboxValues = (ev: React.MouseEvent<HTMLDivElement>, name: string) => {
    setErrorMsg("");
    if (!isPrimaryUser) {
      return
    }

    if (checkboxRefs.current[name]?.current) {
      checkboxRefs.current[name].current!.click();
      setCheckboxRegisterInfo((prevRegisterInfo) => ({
        ...prevRegisterInfo,
        [name]: checkboxRefs.current[name].current!.checked,
      }));
    }
  };

  const checkForTrue = (obj: any) => {
    const values = Object.values(obj);
    return values.includes(true);
  };

  const registerUser = async (ev: SubmitEvent) => {
    ev.preventDefault();

    if (registerInfo.phone.length <= 9 || registerInfo.organisation.length <= 2 || !registerInfo.phone.match(/^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/) ) {
      return;
    }
    setErrorMsg("");

    if (checkForTrue(checkboxRegisterInfo)) {
      const filteredIds = [];
      for (const item of userCategoryData) {
        for (const key in checkboxRegisterInfo) {
          if (checkboxRegisterInfo[key] && item.name === key) {
            filteredIds.push(item.id);
          }
        }
      }
      const payload = {
        email: userState.user.email,
        phone_number: parseInt(registerInfo.phone),
        organization_name: registerInfo.organisation,
        registered_with_sebi: false,
        registered_with_rbi: false,
        technical_service_provider: false,
        user_category: filteredIds,
        // pan: registerInfo?.pan,
        // gstin: registerInfo?.gstin,
        // billing_address: registerInfo?.billing_address,
        // authorised_signatory: registerInfo?.authorised_signatory
      };

      const returnResponse = await dispatch(registerNewUser(payload));
      if (returnResponse.isLoggedIn) {
        if (userState.redirectionUrl !== '') {
          navigate(userState.redirectionUrl);
          dispatch(setRedirectionUrl(''))
        }
        reset();
        setRegisterInfo({ organisation: "", phone: "",
          //  pan: "", gstin: "" , billing_address: "", authorised_signatory: "" 
          });
        setLoginInfo({ email: "", otp: "" });
        dispatch(setShowLoginModal(false));
        dispatch(setFirstTimeUser(false));
        let obj = {}
        Object.keys(checkboxRegisterInfo).forEach(label => obj = { ...obj, [label]: false })
        setCheckboxRegisterInfo(obj)

      }
    } else {
      setErrorMsg("You need to check at least one of the above checkbox options.");
    }
  };


  return (
    <Modal show={userState.showLoginModal} className="login-modal" centered>
      <Modal.Header className="justify-content-center login-modal-header border-0 position-relative">
        <div className="cursor-pointer login-modal-close text-center" onClick={closeModal}>
          <img width="25" height="25" src={closeIcon} alt="close" />
        </div>
        <Modal.Title className="weight-400 text-sec-color">
          Welcome to <strong className="w-700">KFintech</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="login-modal-body border-0">
        {userState.emailVerified === false && userState.isFirstTimeUser === false && (
          <form className="login-form" onSubmit={onSubmitForm} noValidate>
            <div className="">
              <input
                maxLength={100}
                minLength={10}
                required
                type="email"
                className="w-100 email-input mf-input-field"
                name="email"
                placeholder="Your Email Address"
                pattern="^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
                onChange={setInputValue}
                {...bindValue("email")}
                value={loginInfo.email}
              />
              {loginInfo.email.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {loginInfo.email.length !== 0 && loginInfo.email.length < 10 && <p className="mb-0 error-msg weight-500">Email can't have less than 10 characters</p>}
              {loginInfo.email.length > 10 && !loginInfo.email.match(/^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}/) && <p className="mb-0 error-msg weight-500">Invalid Email ID</p>}
              {errorMsg.length !== 0 && <p className="mb-0 error-text-color weight-500 font-13 mt-2">{errorMsg}</p>}
            </div>

            <button disabled={loginInfo.email.length < 10} className="mf-submit-btn text-capitalize primary-bg-color text-white border-0 w-100 mt-4 weight-400" type="submit">
              continue
            </button>
          </form>
        )}

        {userState.emailVerified && userState.OTPRequested && (
          <form className="login-form" onSubmit={onSubmitOTPForm} noValidate>
            <div className="login-otp-section">
              <div className="mb-0 otp-title font-16 text-center weight-400 text-primary-color">
                Enter the OTP sent to given email id <span className="weight-500 break-word">{loginInfo.email}</span>
                <div onClick={editEmail} className="email-edit-img-container d-inline ms-2 cursor-pointer">
                  <img width={12} height={12} src={editIcon} alt="edit" />
                </div>
              </div>

              <OTPInput
                value={loginInfo.otp}
                onChange={setInputValue}
                numInputs={6}
                shouldAutoFocus={true}
                inputStyle="otp-input w-100 mf-input-field mt-3 ps-2 text-center"
                renderSeparator={<span className="mx-2"></span>}
                renderInput={(props) => (
                  <input
                    name="otp"
                    id="otpInput"
                    required
                    {...props}
                  />
                )}
              />
              {OTPResent && <p className="mb-2 font-16 weight-500 mt-3 text-center text-success">Resent OTP to your email</p>}
              {otpSeconds !== 0 || otpMinutes !== 0 ? (
                <p className="mb-0 font-13 weight-500 mt-3">
                  <span className="text-primary-color cursor-pointer resend-link-container-disabled">Resend OTP</span> in
                  {"  0" + otpMinutes + " : " + `${otpSeconds < 10 ? "0" + otpSeconds : otpSeconds}`} seconds
                </p>
              ) : (
                <></>
              )}
              {otpSeconds === 0 && otpMinutes === 0 && (
                <p className="mb-0 font-13 weight-500 mt-3 resend-link-container">
                  <span className="text-primary-color cursor-pointer" onClick={resendOTP}>
                    Resend OTP
                  </span>
                </p>
              )}
            </div>
            <button disabled={loginInfo.otp.length !== 6} className="mf-submit-btn text-capitalize primary-bg-color text-white border-0 w-100 mt-4 weight-400" type="submit">
              continue
            </button>
          </form>
        )}

        {/* Registertration form for new user */}

        {userState.isFirstTimeUser && (
          <form className="register-form mf-new-user" onSubmit={registerUser} noValidate>
            <div className="register-input-container registered-email-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="email">
                your email address
              </label>
              <input disabled type="text" name="email" id="email" className="w-100 registeredEmail text-primary-color font-18 weight-400" value={userState.user.email} />
            </div>
            <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="phone">
                phone number
              </label>
              <input
                type="text"
                name="phone"
                id="phone"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={10}
                minLength={10}
                pattern="^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$"
                required
                onChange={setInputValue}
                {...bindValue("phone")}
                value={registerInfo.phone}
              />
              {registerInfo.phone.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo.phone.length !== 0 && registerInfo.phone.length < 10 && <p className="mb-0 error-msg weight-500">Phone number can't have less than 10 numbers</p>}
              {registerInfo.phone.length >= 10 && !registerInfo.phone.match(/^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/) && <p className="mb-0 error-msg weight-500">Invalid phone number</p>}
            </div>
            <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="organisation">
                organization name
              </label>
              <input
                type="text"
                name="organisation"
                id="org"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={200}
                minLength={3}
                pattern="[A-Za-z0-9+-.,@&$() ]+"
                required
                onChange={setInputValue}
                {...bindValue("organisation")}
                value={registerInfo.organisation}
                disabled={!isPrimaryUser}
              />
              {registerInfo.organisation.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo.organisation.length !== 0 && registerInfo.organisation.length < 3 && <p className="mb-0 error-msg weight-500">Organisation name can't have less than 3 characters</p>}
              {registerInfo.organisation.length >= 10 && !registerInfo.organisation.match(/^[A-Za-z0-9+-.,@&$() ]+$/) && (
                <p className="mb-0 error-msg weight-500">Organisation name can't contain special characters other than +-.,@&$()</p>
              )}
            </div>

            {/* //PAN And GSTIN Fields added as per new requirements */}
            {/* <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="pan">
                PAN
              </label>
              <input
                type="text"
                name="pan"
                id="pan"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={10}
                minLength={10}
                pattern="[A-Za-z0-9+-.,@&$() ]+"
                required
                onChange={setInputValue}
                {...bindValue("pan")}
                value={registerInfo.pan}
                disabled={!isPrimaryUser}
              />
              {registerInfo?.pan?.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo?.pan?.length !== 0 && (registerInfo?.pan ?? "").length < 3 && <p className="mb-0 error-msg weight-500">PAN number can't have less than 10 characters</p>}
              {(registerInfo?.pan??"").length >= 10 && !registerInfo?.pan?.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/) && (
                <p className="mb-0 error-msg weight-500">(eg:- AAACH2702H)</p>
              )}
            </div>

            <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="gstin">
                GSTIN
              </label>
              <input
                type="text"
                name="gstin"
                id="gstin"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={15}
                minLength={15}
                pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                required
                onChange={setInputValue}
                {...bindValue("gstin")}
                value={registerInfo.gstin}
                disabled={!isPrimaryUser}
              />
              {registerInfo?.gstin?.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo?.gstin?.length !== 0 && (registerInfo?.gstin ?? "")?.length < 3 && <p className="mb-0 error-msg weight-500">GSTIN can't have less than 15 characters</p>}
              {(registerInfo?.gstin ?? "")?.length >= 15 && !registerInfo?.gstin?.match(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/) && (
                <p className="mb-0 error-msg weight-500">eg:- 27AAAPA1234A1Z5</p>
              )}
            </div>
            <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="billing_address">
                Billing Address
              </label>
              <input
                type="text"
                name="billing_address"
                id="billing_address"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={200}
                minLength={15}
                pattern="[A-Za-z0-9.,/-\s]+"
                required
                onChange={setInputValue}
                {...bindValue("billing_address")}
                value={registerInfo.billing_address}
                disabled={!isPrimaryUser}
              />
              {registerInfo?.billing_address?.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo?.billing_address?.length !== 0 && (registerInfo?.billing_address ?? "")?.length < 3 && <p className="mb-0 error-msg weight-500">Address can't have less than 15 characters</p>}
              {(registerInfo?.billing_address ?? "")?.length >= 15 && !registerInfo?.billing_address?.match(/[A-Za-z0-9.,/-\s]+$/) && (
                <p className="mb-0 error-msg weight-500">Address name can't contain special characters other than +-,&()</p>
              )}
            </div>
            <div className="register-input-container mb-3">
              <label className="mf-input-label text-capitalize font-13 weight-400" htmlFor="authorised_signatory">
                Authorized Signatory
              </label>
              <input
                type="text"
                name="authorised_signatory"
                id="authorised_signatory"
                className="w-100 text-primary-color font-18 weight-400 mf-input-field"
                maxLength={100}
                minLength={3}
                pattern="[A-Za-z0-9+-.,@&$() ]+"
                required
                onChange={setInputValue}
                {...bindValue("authorised_signatory")}
                value={registerInfo.authorised_signatory}
                disabled={!isPrimaryUser}
              />
              {registerInfo?.authorised_signatory?.length === 0 && <p className="mb-0 error-msg weight-500">field is required</p>}
              {registerInfo?.authorised_signatory?.length !== 0 && (registerInfo?.authorised_signatory ?? "")?.length < 3 && <p className="mb-0 error-msg weight-500">Signatory can't have less than 3 characters</p>}
              {(registerInfo?.authorised_signatory ?? "")?.length >= 15 && !registerInfo?.authorised_signatory?.match(/[A-Za-z\s]+$/) && (
                <p className="mb-0 error-msg weight-500">Signatory name can't contain special characters</p>
              )}
            </div> */}

            {userCategoryData.map((item: any) => (
              <div className="register-input-container mb-3 d-flex align-items-center" key={item.id}>
                <div className="mf-checkbox" data-checked={checkboxRegisterInfo[item.name]} onClick={(ev) => setCheckboxValues(ev, item.name)}>
                  <input disabled={!isPrimaryUser} ref={checkboxRefs.current[item.name]} type="checkbox" name={item.name} id={`${item.name}Registration`} className="d-none" />
                </div>
                <p className="mb-0 text-primary-color font-16 weight-400 ms-2">{item.name}</p>
              </div>
            ))}

            {errorMsg.length !== 0 && <p className="mb-0 error-text-color weight-500 font-13 mt-2">{errorMsg}</p>}
            <button disabled={registerInfo.organisation.length < 3 || registerInfo.phone.length < 10 || !Object.values(checkboxRegisterInfo).includes(true)} className="mf-submit-btn text-capitalize primary-bg-color text-white border-0 w-100 mt-2 weight-400" type="submit">
              continue
            </button>
          </form>
        )}

        <p className="mb-0 weight-400 login-acknowledgement text-center font-14 mt-3">
          By proceeding, I agree to{" "}
          <span onClick={() => openURL("/terms-of-use", "open")} className="weight-500 cursor-pointer">
            T & C,{" "}
          </span>
          <span className="weight-500 cursor-pointer" onClick={() => openURL("/privacy-policy", "open")}>
            Privacy Policy
          </span>
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
